import { render, staticRenderFns } from "./PageTerms.vue?vue&type=template&id=f6c8dcf8&scoped=true&"
import script from "./PageTerms.vue?vue&type=script&lang=js&"
export * from "./PageTerms.vue?vue&type=script&lang=js&"
import style0 from "../../styles/content-page.css?vue&type=style&index=0&id=f6c8dcf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c8dcf8",
  null
  
)

export default component.exports